"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTag = exports.StyledCloseIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _StyledIcon = _interopRequireDefault(require("../Icon/StyledIcon"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["children", "className", "prefixCls", "size", "checkable", "checked", "visible", "extraCls", "icon", "closable", "noBorder"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledContainer = function StyledContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    prefixCls = _ref.prefixCls,
    size = _ref.size,
    checkable = _ref.checkable,
    checked = _ref.checked,
    visible = _ref.visible,
    extraCls = _ref.extraCls,
    icon = _ref.icon,
    closable = _ref.closable,
    noBorder = _ref.noBorder,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var prefix = prefixCls ? prefixCls : className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(StyledInnerTag, (0, _extends2.default)({
    prefixCls: prefix,
    $size: size,
    $checkable: checkable,
    $checked: checked,
    $visible: visible,
    $noBorder: noBorder,
    className: (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefix), true), "".concat(prefix, "-checkable"), checkable), "".concat(prefix, "-checkable-checked"), checked), extraCls),
    $icon: icon,
    $closable: closable
  }, rest), children(prefix));
};
var StyledTag = exports.StyledTag = (0, _ykbStyledComponents.default)(StyledContainer).withConfig({
  componentId: "ykb-ui__sc-b4yo1w-0"
})([""]);
var colorMixin = function colorMixin(color) {
  var switchKey = '';
  if (typeof color === 'string') {
    switchKey = color.toLowerCase();
  } else {
    return (0, _ykbStyledComponents.css)(["background-color:", ";color:", ";border-color:", ";", "{color:", ";margin-right:6px;font-size:16px;vertical-align:sub;&:hover{color:", ";}}"], function (props) {
      return props.theme.colorPalette.grey1;
    }, function (props) {
      return props.theme.colorPalette.grey7;
    }, function (props) {
      return props.theme.colorPalette.grey5;
    }, _StyledIcon.default, function (props) {
      return props.theme.colorPalette.grey6;
    }, function (props) {
      return props.theme.colorPalette.grey7;
    });
  }
  if (['blue', 'red', 'yellow', 'green', 'grey', 'volcano', 'orange', 'gold', 'lime', 'cyan', 'geekblue', 'purple', 'magenta'].indexOf(switchKey) > -1) {
    return (0, _ykbStyledComponents.css)(["background-color:", ";color:", ";border-color:", ";", "{color:", ";margin-right:6px;font-size:16px;vertical-align:sub;&:hover{color:", ";}}"], function (props) {
      return props.theme.colorPalette[switchKey + 1];
    }, function (props) {
      return props.theme.colorPalette[switchKey + 7];
    }, function (props) {
      return props.theme.colorPalette[switchKey + 5];
    }, _StyledIcon.default, function (props) {
      return props.theme.colorPalette[switchKey + 6];
    }, function (props) {
      return props.theme.colorPalette[switchKey + 7];
    });
  } else {
    return (0, _ykbStyledComponents.css)(["background-color:", ";color:#fff;border-color:transparent;", "{color:", ";margin-right:6px;font-size:16px;vertical-align:sub;&:hover{color:", ";}}"], color, _StyledIcon.default, function (props) {
      return props.theme.colorPalette.neutral1;
    }, function (props) {
      return props.theme.colorPalette.neutral2;
    });
  }
};
var StyledInnerTag = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-b4yo1w-1"
})(["&.", "{", ";display:inline-block;height:auto;margin-right:8px;font-size:", ";line-height:", ";white-space:nowrap;border:", " ", " ", ";", ";border-radius:", ";opacity:1;transition:all 0.3s;", " ", " ", " &:hover{opacity:0.85;}a,a:hover{color:", ";}> a:first-child:last-child{display:inline-block;margin:0 -8px;padding:0 8px;}&-checkable{background-color:transparent;border-color:transparent;cursor:pointer;&:not(&-checked):hover{color:", ";}&:active,&-checked{color:#fff;}&-checked{background-color:", ";}&:active{background-color:", ";}}", "}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.mixins.resetComponent(_ykbStyledComponents.css);
}, function (props) {
  return props.theme.tag.fontSize[props.$size];
}, function (props) {
  return props.theme.tag.lineHeight[props.$size];
}, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.border.style;
}, function (props) {
  return props.theme.border.colorBase;
}, function (props) {
  return colorMixin(props.color);
}, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.$noBorder && (0, _ykbStyledComponents.css)(["border:none;"]);
}, function (props) {
  return props.$icon ? (0, _ykbStyledComponents.css)(["padding:", ";"], function (props) {
    return props.theme.tag.paddingWithIcon[props.$size];
  }) : (0, _ykbStyledComponents.css)(["padding:", ";"], function (props) {
    return props.theme.tag.padding[props.$size];
  });
}, function (props) {
  return props.$closable && (0, _ykbStyledComponents.css)(["padding-right:", ";"], function (props) {
    return props.theme.tag.closablePaddingRight[props.$size];
  });
}, function (props) {
  return props.theme.color.default7;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary7;
}, function (props) {
  return !props.$visible && !props.$checkable && (0, _ykbStyledComponents.css)(["display:none;"]);
});
var StyledCloseIcon = exports.StyledCloseIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-b4yo1w-2"
})(["margin-left:6px;cursor:pointer;transition:all 0.3s;margin-right:0px !important;"]);